import { DEFAULT_BENTHIC_CLASS_COLORS } from 'components/Tiles/BenthicTileLayer';
import { DEFAULT_REEF_EXTENT_CLASS_COLORS } from 'components/Tiles/ReefExtentTileLayer';
import { DEFAULT_CORTAD_MONTH, DEFAULT_CORTAD_VARIABLE } from 'utils/cortadLayers';

export const DEFAULT_BLEACHING_YEAR = 2005;
export const ALL_BLEACHING_YEARS = null;
export { DEFAULT_CORTAD_MONTH, DEFAULT_CORTAD_VARIABLE };

const buildDefaultBenthicClasses = () => Object.fromEntries(
  Object.entries(DEFAULT_BENTHIC_CLASS_COLORS).map(([className, color]) => [
    className,
    { visible: true, color },
  ]),
);

const buildDefaultReefExtentClasses = () => Object.fromEntries(
  Object.entries(DEFAULT_REEF_EXTENT_CLASS_COLORS).map(([className, color]) => [
    className,
    { visible: true, color },
  ]),
);

const defaultSettings = () => ({
  basemap: 'imagery',
  captionsVisible: true,
  benthicVisible: false,
  benthicClasses: buildDefaultBenthicClasses(),
  reefExtentVisible: false,
  reefExtentClasses: buildDefaultReefExtentClasses(),
  bleachingVisible: false,
  bleachingYear: ALL_BLEACHING_YEARS,
  expeditionTrackVisible: true,
  cortadVisible: false,
  cortadVariable: DEFAULT_CORTAD_VARIABLE,
  cortadMonth: DEFAULT_CORTAD_MONTH,
});

export const getMapLayerSettings = (cacheKey) => {
  const defaults = defaultSettings();
  if (!cacheKey) return defaults;
  try {
    const cached = JSON.parse(window.localStorage.getItem(cacheKey));
    if (!cached || typeof cached !== 'object') return defaults;
    return {
      ...defaults,
      ...cached,
      benthicClasses: { ...defaults.benthicClasses, ...(cached.benthicClasses || {}) },
      reefExtentClasses: { ...defaults.reefExtentClasses, ...(cached.reefExtentClasses || {}) },
    };
  } catch (_) {
    return defaults;
  }
};

export const persistMapLayerSettings = (cacheKey, settings) => {
  if (!cacheKey) return;
  try {
    window.localStorage.setItem(cacheKey, JSON.stringify(settings));
  } catch (_) {
    // Ignore quota / private mode.
  }
};
